import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "../../../Common/Controls/Controls"
import Moment from "react-moment";
import infoSource from "../../../../util/infoSource";
import AppContext from "../../../../Context/AppContext";
import { KTSVG, toAbsoluteUrl } from "../../../../helpers";
import "./subEtapas.css";

const SubEtapas = ({ currentDemanda, currentEtapa, setCurrentNuevaEtapa }) => {
  const { checkUserSession, contextAcreditado, changeLoading } =
    useContext(AppContext);
  const infoUs = checkUserSession();

  useEffect(() => {
    loadInfo();
  }, []);
  const [datatableSubEtapas, setDatatableSubEtapas] = useState({
    columns: [
      {
        label: "",
        field: "objFind",
        width: 0,
      },
      {
        label: "ID",
        field: "AsigDemandaId",
        width: 50,
      },
      {
        label: "Etapa",
        field: "Etapa",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      {
        label: "Fecha de inicio",
        field: "FechaInicio",
        width: 200,
      },
      {
        label: "Fecha de fin",
        field: "FechaFin",
        sort: "asc",
        width: 120,
      },
      {
        label: "Comentario",
        field: "Comentario",
        sort: "asc",
        width: 120,
      },
      {
        label: "Acciones",
        field: "AcreditadoId",
        sort: "disabled",
        width: 80,
      },
    ],
    rows: [],
  });

  async function loadInfo() {
    if (currentEtapa.etapaInfo != null) {
      const listSubetapas = await infoSource.Demandas.SubEtapasDemandas(
        infoUs,
        currentEtapa.etapaInfo.AsigDemandaId,
        currentEtapa.EtapaId
      );
      setDatatableSubEtapas({
        ...datatableSubEtapas,
        rows: listSubetapas.map((item, i) => ({
          objFind: `${item.EtapaNombre} ${item.AsigDEFechaInicio} ${item.AsigDEFechaFinal} `,
          AsigDemandaId: item.AsigDemandaId,
          Etapa: item.EtapaNombre,
          FechaInicio: (
            <Moment
              className={`Fecha_AcreditadoDetalle`}
              locale="es"
              format="MMM DD, YYYY"
              date={item.AsigDefechaInicio}
            />
          ),
          FechaFin: (
            <Moment
              className={`Fecha_AcreditadoDetalle`}
              locale="es"
              format="MMM DD, YYYY"
              date={item.AsigDefechaFinal}
            />
          ),

          Comentario: (
            <div className="comentarioAcreditadoDetalle">
              {item.AsigDecomentarios}
            </div>
          ),
          AcreditadoId: (
            <>
              <button
                className="btnDetalleExpediente"
                onClick={() => {
                  setCurrentNuevaEtapa(item)
                }}
              >
                Editar
              </button>
              <button
                className="btnRemoverExpediente"
                // onClick={() => deleteRow(item.gestionID)}
              >
                <KTSVG
                  path={"/img/Icons/Remove.svg"}
                  className={`svg-icon removeItem`}
                />
              </button>
            </>
          ),
        })),
      });
    }
  }

  return (
    <div>
      <DataTable
        hover
        className="mdbDataSubEtapas"
        data={datatableSubEtapas}
      />
    </div>
  );
};
export default SubEtapas;
